import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateUserInfoPutRequestModel, UpdateUserInfoPutResponseModel } from "@/features/user/services/update-user-info-model";

export class UpdateUserInfoApi {
  /**
   * 利用者情報更新API
   */
  public putUpdateUserInfo = async (
    param: UpdateUserInfoPutRequestModel
  ): Promise<UpdateUserInfoPutResponseModel> => {
    const path = `/api/users/updateinfo`;

    const res = await ApiClient.instance.put<UpdateUserInfoPutResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
